module.exports = __webpack_public_path__ + "img/a-bottom.42ad59aa.png";